import { render, staticRenderFns } from "./CmgHowItWorks.vue?vue&type=template&id=788884fc&scoped=true&lang=pug&"
import script from "./cmg-how-it-works.ts?vue&type=script&lang=ts&"
export * from "./cmg-how-it-works.ts?vue&type=script&lang=ts&"
import style0 from "./CmgHowItWorks.vue?vue&type=style&index=0&id=788884fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788884fc",
  null
  
)

export default component.exports